
<div class="bet-table" [ngClass]="betData.side.includes('b') ? 'blue-bet' : 'red-bet'" *ngIf="betData && betData?.price && betData?.isClosed == false">
  <div id="goto-{{betData?.market_id}}-{{betData?.selection_id}}"></div>
  
  <h5 class="eventname m-0">{{betData?.event_name}} </h5>
  <h4 class="teamname m-0">{{betData.name}}</h4>
  <span class="bet-close" (click)="onCloseBet($event)">
    <img class="img-fluid" src="assets/images/icon/png/x-orderslip.png">
  </span>

  <div class="card mt-1">
    <div class="card-header">
      <p>max bet: {{betData?.max}}</p>
      <p>min bet: {{betData?.min}}</p>
    </div>
    
    <div class="card-body p-1">
      
      <div class="row mx-0">
        <div class="col-6 px-0">
          <label class="m-0">odds</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text" (click)="onChangeOdds('down')">-</div>
            </div>
            <input type="number" class="form-control" [(ngModel)]="betData.price" (change)="validateField()" min="1.01" max="999.99">
            <div class="input-group-prepend">
              <div class="input-group-text" (click)="onChangeOdds('up')">+</div>
            </div>
          </div>
        </div>

        <div class="col-6 px-1">
          <label class="m-0">stake</label>
          <input type="number" pattern="[0-9]*" class="form-control bs_stakes_i" (keypress)="digitOnly($event)" (keydown)="validateField()" (keyup)="validateField()" (change)="validateField()" [(ngModel)]="betData.stake" min="0" placeholder="Min: 000">
        </div>

        <!-- <div class="col-3 px-0">
          <label class="m-0">{{(betData.side.includes('b'))?'Profit':'Loss'}}</label>
          <p class="m-0" [ngClass]="(betData.stake > 0)?(betData.side.includes('b') ? 'text-green' : 'text-red'):''">
            {{((betData.stake) > 0)?(betData.side.includes('b') ? '+' : '-'):''}}
              {{(betData.stake > 0)?(betData.side.includes('b'))?profit.toFixed(2):loss.toFixed(2):'0.00'}}
          </p>
        </div> -->

      </div>

      <div class="row mt-1">
        <div class="col-12">
          <div class="btn-group">
            <button type="button" (click)="onAmountChange(stk)" *ngFor="let stk of betData.stakes;">{{stk.name}}</button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="btn-group">
            <button type="button" class="min-btn" (click)="onMinMaxAmountChange(betData?.min)">min</button>
            <button type="button" class="max-btn" (click)="onMinMaxAmountChange(betData?.max)">max</button>
            <button type="button" class="allin-btn" *ngIf="isLogin()" (click)="onAllInAmountChange()">all in</button>
            <button type="button" class="clear-btn" (click)="onClear()">clear</button>
          </div>
        </div>
      </div>

      <div class="pb-co">
        <button type="button" class="btn-po" [disabled]="isLoading" (click)="orderPlaced()">place order</button>
        <button type="button" class="btn-co" (click)="onCloseBet($event)">cancel order</button>
      </div>

    </div>

  </div>

  <app-loader class="full-overlay" *ngIf="isLoading"></app-loader>

</div>

<!-- <div class="all-btnsPC">
  <button class="place-all">place all</button>
  <button class="cancel-all">cancel all</button>
</div> -->